import { Component, AfterViewInit, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import videojs from 'video.js';

type VideoJsPlayer = ReturnType<typeof videojs>;

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.css']
,
  standalone: false
})
export class VideoComponent implements AfterViewInit, OnDestroy {
  @ViewChild('videoTarget', { static: true }) videoTarget!: ElementRef<HTMLVideoElement>;
  player!: VideoJsPlayer;
  isBuffering = true;
  bufferPercentage = 0;

  ngAfterViewInit() {
    this.player = videojs(this.videoTarget.nativeElement, {
      controls: true,
      autoplay: false,
      preload: 'auto',
      muted: true,
      sources: [
        {
          src: 'https://nvr-proxy.pro-vigil.us/nvr/api/pro/NAS1/729807/nvr_stream_video_buffer/729807/729807CAM1729083015/2024-11-15/09/2024-11-15-09-49-59.mp4?autoplay=1&mute',
          type: 'video/mp4'
        }
      ]
    });

    this.player.on('waiting', () => {
      this.isBuffering = true;
    });

    this.player.on('playing', () => {
      this.isBuffering = false;
    });

    this.player.on('progress', () => {
      const buffered = this.player.buffered();
      const duration = this.player.duration();

      if (buffered && buffered.length > 0 && duration > 0) {
        const bufferedEnd = buffered.end(buffered.length - 1);
        this.bufferPercentage = Math.floor((bufferedEnd / duration) * 100);
      }
    });

    this.player.on('error', (e) => {
      console.error('Video.js error:', e);
    });
  }

  ngOnDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }
}
